export const isHeicFile = (file) => file.type === "image/heic" || file.type === "image/heif";
